import { apiFetch, recoverApiAuthorization } from '../api'

export default class Family {

	static retrieve = async (uuid: string): Promise<any | null> => {
		return apiFetch(`/family/${uuid}`)
			.then(response => {
				if (!response.ok) {
					return null
				} else {
					return response.json()
				}
			})
			.catch(error => {
				recoverApiAuthorization(error)
				return null
			})
	}

	static decline = async (uuid: string): Promise<boolean> => {
		return apiFetch(`/family/${uuid}`, {
			method: 'DELETE'
		})
			.then(response => response.ok)
			.catch(error => {
				recoverApiAuthorization(error)
				return false
			})
	}

	static accept = async (uuid: string): Promise<boolean> => {
		return apiFetch(`/family/${uuid}`, {
			method: 'PUT'
		})
			.then(response => response.ok)
			.catch(error => {
				recoverApiAuthorization(error)
				return false
			})
	}
}
